import React from 'react';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';
import { spanishUrl, spanishStudentUrl } from './urls';
import IframePage from '../IframePages';
import SpanishStudentIFrame from './SpanishStudentIFrame';
import { DISTRICT_OWNER, SCHOOL_ADMIN, TEACHER, STUDENT } from '../../constants/userRoles';
import RoleErrorComponent from '../../components/Error/RoleErrorComponent';

const SPANISH_WIX_URL = 'https://www.go4.twigscience.com/esv1?mode=t1';

const routes = [
    <AuthenticatedLayoutRoute
        key={spanishUrl}
        exact
        path={spanishUrl}
        roles={[DISTRICT_OWNER, SCHOOL_ADMIN, TEACHER]}
        RoleErrorComponent={RoleErrorComponent}
    >
        <IframePage title="Español" urls={{ default: SPANISH_WIX_URL }} />
    </AuthenticatedLayoutRoute>,
    <AuthenticatedLayoutRoute
        key={spanishStudentUrl}
        exact
        path={spanishStudentUrl}
        roles={[DISTRICT_OWNER, SCHOOL_ADMIN, TEACHER, STUDENT]}
        RoleErrorComponent={RoleErrorComponent}
    >
        <SpanishStudentIFrame />
    </AuthenticatedLayoutRoute>,
];

export default routes;
